import React, {useMemo, useState} from "react";
import styles from "./styles.scss";
import IconComponent from "../../../../components/commons/IconComponent";
import MagazineCustomSizeModal from "../MagazineCustomSizeModal";
import {connect} from "react-redux";
import {getTranslation} from "../../../../store/getters";
import {predefinedSizes, sizeUnits} from "../../../../utils/pageSize";

function MagazineSizeDropdown({translation, onClick}) {
    const [isModalOpened, setIsModalOpened] = useState(false);

    const sizes = useMemo(() => Object
        .keys(predefinedSizes)
        .map(slug => ({
            ...predefinedSizes[slug],
            slug, title: translation(`size-dropdown-predefined-${slug}-title`),
        })), [translation]);

    const onClickOpenModal = () => setIsModalOpened(true);

    const onClickCloseModal = () => setIsModalOpened(false);

    const onClickSize = ({unit, width, height}) => {
        const m = sizeUnits[unit] || 1;
        onClick({
            width: width * m,
            height: height * m,
        });
    };

    return (
        <>
            {isModalOpened &&
                <div className={styles.dropdown}>
                    <MagazineCustomSizeModal onClose={onClickCloseModal} onSubmit={onClickSize}/>
                </div>
            }
            <div className={styles.container}>
                <button className={`${styles.btn} ${isModalOpened && styles.active}`} onClick={onClickOpenModal}>
                    <div className={styles.icon}>
                        <IconComponent icon="custom-size"/>
                    </div>
                    {translation("size-dropdown-custom-size-title")}
                </button>
                {sizes.map((s) => (
                    <button key={s.slug} className={styles.btn} onClick={() => onClickSize(s)}>
                        {s.title}&nbsp;
                        <span className={styles.addon}>({s.width}x{s.height} {s.unit})</span>
                    </button>
                ))}
            </div>
        </>
    );
}

export default connect(state => ({
    translation: getTranslation(state),
}))(MagazineSizeDropdown);


// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineSizeDropdown/index.js